export default __webpack_public_path__ + "static/media/3.062bf1e6.png";